import { AfterViewInit,Component, Inject, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import { MatTable } from '@angular/material/table';
import { TipoEvaluacionService } from 'app/main/services/tipo-evaluacion.service';
import { EscenarioService } from 'app/main/services/escenario.service';
import { EstructuraJerarquicaService } from 'app/main/services/estructura-jerarquica.service';
import { UsersService } from 'app/main/services/users.service';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import {TranslateService} from '@ngx-translate/core';
import { Escenario } from 'app/main/models/escenario.model';
import {MatCalendar} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS,MAT_DATE_LOCALE, MatDateFormats} from '@angular/material/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

@Component({
  selector: 'app-dialog-box',
  templateUrl: './consolidacion-dialog-box.component.html',
  styleUrls: ['./consolidacion-dialog-box.component.scss'],

})
export class ConsolidacionDialogBoxComponent {

  action: string;
  LOCAL_DATA: any;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ConsolidacionDialogBoxComponent>,
    public userService: UsersService,
    public translate: TranslateService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Escenario) {
    console.log(data);
    this.LOCAL_DATA = {...data};
    this.action = this.LOCAL_DATA.action;
    //Object.assign(this, { multi });
  }

  doAction(): void{
    console.log('im here');
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }


  ngOnInit(): void {

  }

}
